// extracted by mini-css-extract-plugin
export default {"container":"Accordeon_container__Y8oSo","title":"Accordeon_title__v1FBB","icon":"Accordeon_icon__US9Ag"};